<template>
  <div class="gerenciamento-grupo">
    <g-card class="card-gerenciamento-grupo"  :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Grupos </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza" altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="limpaFiltro"
            />

            <g-button
            class="plus-button"
            corIconeClass="#FFF"
            cor="#4F2C19"
            altura="35px"
            largura="45px"
            icone="pi pi-plus"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            @click="this.popupInclusao=true"

            />

            <g-button
            class="buscar-button-header-filtro"
            largura="150px" icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="14px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="getGrupoByFiltro"
            >
                BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="gerenciamento-grupo-conteudo espacamento-filtros">            
          <div class="filtro-nome-grupo">
            <div class="titulo-conteudo-filtros"> Grupo </div>
            <PInputText class="grupo-input input-label" v-model="grupoViewModel.NomeGrupo" placeholder="Insira o nome do grupo"/>
          </div>
          
          <div class="filtro-lider-grupo">
            <div class="titulo-conteudo-filtros"> Líder do Grupo </div>
            <PDropDown 
             class="lider-input input-label" 
             :options="UsuarioLiderArray" 
             optionValue="id" 
             v-model="grupoViewModel.UsuarioLiderId"
             optionLabel="usuarioLider"
             placeholder="Selecione o líder"/>
          </div>         
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="14px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        @click="getGrupoByFiltro"
        >
          BUSCAR
        </g-button>
      </div>
    </g-card>
    
    <g-card v-if="mensagemvazio" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!mensagemvazio" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      Titulo=""
      :Excluivel="true"
      v-on:excluir="abrePopupExclusao"
      :colunas="Colunas"
      :valores="GrupoArray"
      v-on:duploClickLinha="detalhesGrupo"
      >
      </g-data-table>
    </g-card>

    <PDialog  :closable="false" v-model:visible="popupInclusao" :modal="true" :showHeader="false">
                    <div class="titulo-popup-finalizado"> Deseja Adicionar um Grupo? </div>

                <div class="botoes-popup button-popup">
                    <div>
                        <g-button
                        tipo="cinza"
                        negritoTexto 
                        largura="230px" 
                        altura="35px" 
                        @click="this.popupInclusao=false"
                        >
                            CANCELAR
                        </g-button>
                    </div>
                    <div>
                        <g-button
                        negritoTexto
                        largura="230px" 
                        altura="35px" 
                        @click="this.$router.push('/adicionar-grupo')"
                        >
                            ADICIONAR  
                        </g-button>
                    </div>
                </div>
            </PDialog>

            <PDialog :showHeader="false" :closable="false" v-model:visible="popupExcluir">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> {{this.mensagem}} </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="popupExcluir = false"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="excluir"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import GerenciamentoGrupos from "./GerenciamentoGrupos.js";
export default GerenciamentoGrupos;
</script>

<style scoped>
@media (min-width:310px) {
    
}

@media (min-width:368px) {

}

@media (min-width:500px) {
.gerenciamento-grupo-conteudo {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 22em));
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
.filtro-nome-grupo { grid-area: 1 / 1 / 2 / 2; }
.filtro-lider-grupo { grid-area: 1 / 2 / 2 / 3; }
}

@media (min-width:801px) {
.gerenciamento-grupo-conteudo {
  grid-template-columns: repeat(2, minmax(4em, 22em)) auto;
}
}

@media (min-width:1025px) { 

}

@media (min-width:1281px) { 
    
}

</style>
